export class TimeSlot {
  start: Date;
  end: Date;
  participants: Array<{ providerId: number; }>;

  constructor(json: ITimeSlotApiResponse) {
    this.start = new Date(json.start);
    this.end = new Date(json.end);
    this.participants = json.participants.map((participant) => ({
      providerId: +participant.provider_id
    }));
  }
}

export interface ITimeSlotApiResponse {
  start: Date;
  end: Date;
  participants: Array<{ provider_id: string; }>;
}
